"use client";

import { useTranslation } from "react-i18next";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import PageHero from "@/components/landing/PageHero";
import { AnimatedSection } from "@/hooks/useScrollAnimation";
const contactDoctor = "/assets/contact-doctor.jpg";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <Navbar />

      <PageHero
        title={t("contact.heroTitle")}
        subtitle={t("contact.heroSubtitle")}
        backgroundImage={contactDoctor}
      />

      <section className="py-16 px-6 lg:px-12 bg-white">
        <AnimatedSection className="max-w-[700px] mx-auto" delay={100}>
          <iframe
            src="https://support.legacy-hc.com/widget/form/FmdCss8ypIsncydFkC37"
            style={{ width: "100%", height: "664px", border: "none", borderRadius: "4px" }}
            id="inline-FmdCss8ypIsncydFkC37"
            data-layout='{"id":"INLINE"}'
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Contact Form"
            data-height="664"
            data-layout-iframe-id="inline-FmdCss8ypIsncydFkC37"
            data-form-id="FmdCss8ypIsncydFkC37"
            title="Contact Form"
          />
        </AnimatedSection>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
